import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraButton, SpecraInlineBanner } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { STALE_BUNDLE_COPY } from '../StaleBundleNotice';
/** In-card stand-in for a tool result this bundle does not know how to render. */ export function StaleBundleCardHint({ onReload }) {
    return /*#__PURE__*/ _jsx(SpecraInlineBanner, {
        action: /*#__PURE__*/ _jsx(SpecraButton, {
            "data-testid": Testids.assistant.staleBundleReload,
            onClick: ()=>(onReload ?? (()=>window.location.reload()))(),
            size: "sm",
            variant: "secondary",
            children: "Reload"
        }),
        "data-testid": Testids.assistant.staleBundleCardHint,
        title: "Update available",
        tone: "info",
        variant: "framed",
        children: STALE_BUNDLE_COPY
    });
}
